import React from 'react';
import { Box, Typography } from '@mui/material';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

const SectionHeader = ({ title, subtitle, action }: SectionHeaderProps) => (
  <Box>
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography
        variant="subtitle2"
        fontWeight="var(--font-weight-semibold)"
        color="var(--color-greyscale-900)"
      >
        {title}
      </Typography>
      {action}
    </Box>
    {subtitle && (
      <Typography
        fontSize="var(--font-size-base)"
        fontWeight="var(--font-weight-regular)"
        color="var(--color-greyscale-800)"
        lineHeight="var(--line-height-lg)"
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);

SectionHeader.displayName = 'SectionHeader';

export default SectionHeader;
